import React from 'react';
import {formBodyType} from '../../../../../util/uiconstants';
import StandaloneHelixV2 from './components/StandaloneHelixV2';

const configuration = {
	[formBodyType.HelixComponentV2]: {
		render: (props) => <StandaloneHelixV2 {...props} />
	}
};

export default function getComponent(bodyTypeId) {
	return configuration[bodyTypeId] ? configuration[bodyTypeId] : null;
}
